import { initialChartSettings } from './utils';
import { CHART_GROUPS_PATH_MAX_COUNT } from '../../../components/Chart/constants/utils';
import { IChartSettings } from '../../../components/Chart/interfaces';
import { IPathAnalysis } from '../../../utils/apollo/responseTypes';
import { assertNotNil } from '../../../utils/types';
import { IDisplayedSliceSetting } from '../../../components/Chart/interfaces';
import { generateDisplayedSliceSettings } from './utils';
import { UnreachableCaseError } from 'ts-essentials';
import { CHART_TYPES } from '../../../components/Chart/constants/chartTypes';

export const generatePathDefaultSettings = (
  analysis: IPathAnalysis,
): IChartSettings => {
  let displayedSliceSettings: IDisplayedSliceSetting[];
  assertNotNil(analysis.data);
  const modeValue = analysis.data.modeValue;
  switch (modeValue.__typename) {
    case 'SankeyPathModeValue': {
      displayedSliceSettings = generateDisplayedSliceSettings({
        analysis: {
          data: {
            base: modeValue.base,
            slices: modeValue.flows,
          },
        },
        visibleCount: CHART_GROUPS_PATH_MAX_COUNT,
      });
      break;
    }
    case 'TopPathsPathModeValue': {
      displayedSliceSettings = generateDisplayedSliceSettings({
        analysis: {
          data: modeValue,
        },
      });
      break;
    }
    default:
      throw new UnreachableCaseError(modeValue);
  }

  return {
    ...initialChartSettings,
    chartType: CHART_TYPES.PATH,
    displayedSliceSettings,
    displaySeq: 4,
    pathEventsPerStep: 4,
    topBreakdownsValue: CHART_GROUPS_PATH_MAX_COUNT,
  };
};
